"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../../../classnames"));
var Badge_1 = __importDefault(require("../../buttons/Badge"));
var SelectFieldCaret_1 = __importDefault(require("./SelectFieldCaret"));
var Icon_1 = __importDefault(require("../../Icon"));
var PlainButton_1 = __importDefault(require("../../buttons/PlainButton"));
var SelectFieldMultiValueBadge = function (_a) {
    var option = _a.option, onDeselect = _a.onDeselect;
    var MAX_LENGHT = 40;
    var label = option.label, value = option.value, category = option.category, categoryIcon = option.categoryIcon, actionButtonCallback = option.actionButtonCallback, actionAriaLabel = option.actionAriaLabel;
    var onClick = function (event) {
        event.stopPropagation();
        onDeselect(value, category || "");
    };
    if (categoryIcon) {
        if (actionButtonCallback) {
            return (react_1.default.createElement("div", { className: "option-group" },
                react_1.default.createElement(Badge_1.default, { id: "option-tag", "aria-label": "Unselect " + label, icon: "close", onClick: onClick },
                    label.length > MAX_LENGHT ? label.substring(0, MAX_LENGHT) + "..." : label,
                    " ",
                    react_1.default.createElement(Icon_1.default, { icon: categoryIcon, className: "category-icon" })),
                react_1.default.createElement(PlainButton_1.default, { id: "option-action", "aria-label": actionAriaLabel, className: "option-action", onClick: function () { actionButtonCallback(value, category, label); } },
                    react_1.default.createElement(Icon_1.default, { icon: "plus" })),
                " "));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Badge_1.default, { id: "option-tag", "aria-label": "Unselect " + label, icon: "close", onClick: onClick },
                label.length > MAX_LENGHT ? label.substring(0, MAX_LENGHT) + "..." : label,
                " ",
                react_1.default.createElement(Icon_1.default, { icon: categoryIcon, className: "category-icon" })),
            " "));
    }
    if (typeof label === "string") {
        if (actionButtonCallback) {
            return (react_1.default.createElement("div", { className: "option-group" },
                react_1.default.createElement(Badge_1.default, { id: "option-tag", "aria-label": "Unselect " + label, icon: "close", onClick: onClick }, label),
                react_1.default.createElement(PlainButton_1.default, { id: "option-action", "aria-label": actionAriaLabel, className: "option-action", onClick: function () { actionButtonCallback(value, category, label); } },
                    react_1.default.createElement(Icon_1.default, { icon: "plus" })),
                " "));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Badge_1.default, { id: "option-tag", "aria-label": "Unselect " + label, icon: "close", onClick: onClick }, label.length > MAX_LENGHT ? label.substring(0, MAX_LENGHT) + "..." : label),
            " "));
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Badge_1.default, { id: "option-tag", icon: "close" }));
};
var SelectFieldMultiValue = /** @class */ (function (_super) {
    __extends(SelectFieldMultiValue, _super);
    function SelectFieldMultiValue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyDown = function (event) {
            event.stopPropagation();
            var _a = _this.props, display = _a.display, onClose = _a.onClose, onDeselect = _a.onDeselect, onOpen = _a.onOpen, open = _a.open, value = _a.value;
            switch (event.key) {
                case "Backspace":
                    if (!display && value) {
                        onDeselect(value[value.length - 1], "");
                    }
                    break;
                case "Enter":
                    if (!open) {
                        onOpen();
                    }
                    break;
                case "Escape":
                    if (open) {
                        onClose();
                    }
                    break;
                default:
                    break;
            }
        };
        return _this;
    }
    SelectFieldMultiValue.prototype.getCurrentOptions = function () {
        var _a = this.props, options = _a.options, value = _a.value;
        if (!value) {
            return [];
        }
        return value.map(function (item) {
            if (typeof item === "string" || typeof item === "number") {
                return options.find(function (option) { return option.value === item; }) // given option
                    || { label: item, value: item }; // created option
            }
            return options.find(function (option) { return option.value === item.value
                && option.category === item.category; }) // given option
                || { label: item, value: item }; // created option
        });
    };
    SelectFieldMultiValue.prototype.render = function () {
        var _a = this.props, ariaLabel = _a.ariaLabel, disabled = _a.disabled, display = _a.display, imageIconPath = _a.imageIconPath, inputRef = _a.inputRef, name = _a.name, onChange = _a.onChange, onDeselect = _a.onDeselect, onOpen = _a.onOpen, open = _a.open, placeholder = _a.placeholder, onInpuFocus = _a.onInpuFocus, onInputBlur = _a.onInputBlur, placeholderIsVisible = _a.placeholderIsVisible;
        var className = classnames_1.default("chq-ffd--ctrl", { "chq-ffd--ctrl-fc": open });
        var currentOptions = this.getCurrentOptions();
        return (react_1.default.createElement("div", { role: "button", tabIndex: disabled ? -1 : 0, onClick: disabled ? undefined : onOpen, onKeyDown: this.handleKeyDown, className: className },
            currentOptions.map(function (option, index) {
                var value = option.value, category = option.category;
                return (react_1.default.createElement(react_1.default.Fragment, { key: category ? category + "-" + value : value },
                    react_1.default.createElement("input", { "aria-label": name + " " + index, type: "hidden", id: name + "[" + index + "]", name: name + "[]", value: option.value }),
                    react_1.default.createElement(SelectFieldMultiValueBadge, { option: option, onDeselect: onDeselect })));
            }),
            imageIconPath && (react_1.default.createElement("img", { className: "chq-ffd--sl--icon", src: imageIconPath, alt: "Input icon" })),
            react_1.default.createElement("input", { "aria-label": ariaLabel || "Search", type: "text", className: "chq-ffd--sl--match", disabled: disabled, ref: inputRef, onChange: onChange, onKeyDown: this.handleKeyDown, onFocus: onInpuFocus, onBlur: onInputBlur, value: display }),
            placeholderIsVisible && react_1.default.createElement("span", { id: "sl-placeholder", className: "chq-ffd--sl--place" }, placeholder),
            react_1.default.createElement(SelectFieldCaret_1.default, { open: open })));
    };
    return SelectFieldMultiValue;
}(react_1.default.Component));
exports.default = SelectFieldMultiValue;
